/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EditCommentResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      id: {
        type: 'string',
      },
      content: {
        type: 'string',
      },
      file: {
        type: 'File',
      },
    },
  }],
} as const;
